import { Component } from 'react';
import { discoverJobsRerun, gscJobsRerun } from './query';
import Loading from '../../components/Loading';
import { withTranslation } from 'react-i18next';

class ExtraButtons extends Component {
    constructor() {
        super();

        this.onRerunGsc = this.onRerunGsc.bind(this);
        this.onRerunDiscover = this.onRerunDiscover.bind(this);

        this.state = {
            isLoadingGsc: false,
            isLoadingDiscover: false,
        };
    }

    async onRerunGsc() {
        try {
            this.setState({
                isLoadingGsc: true,
            });
            await gscJobsRerun(this.props.current_url, this.props.csrf_token);
        } catch (err) {
            console.log(err);
        } finally {
            this.setState({
                isLoadingGsc: false,
            });
        }
    }

    async onRerunDiscover() {
        try {
            this.setState({
                isLoadingDiscover: true,
            });
            await discoverJobsRerun(this.props.current_url, this.props.csrf_token);
        } catch (err) {
            console.log(err);
        } finally {
            this.setState({
                isLoadingDiscover: false,
            });
        }
    }

    render() {
        const { t } = this.props;

        return (
            <div className="table-additional-view">
                <div className="table-additional-view-btns">
                    <div className="table-header-extra-view-box-btns">
                        <div className="table-additional-view-btn-groups">
                            <button onClick={this.onRerunGsc} disabled={this.state.isLoadingGsc}>
                                <span style={{ marginRight: '5px' }}>
                                    {t('domain_runs_qa.rerun_gsc')}
                                </span>
                                {this.state.isLoadingGsc && <Loading onlyPreloader />}
                            </button>
                            <button
                                onClick={this.onRerunDiscover}
                                disabled={this.state.isLoadingDiscover}
                            >
                                <span style={{ marginRight: '5px' }}>
                                    {t('domain_runs_qa.rerun_discover')}
                                </span>
                                {this.state.isLoadingDiscover && <Loading onlyPreloader />}
                            </button>
                        </div>
                    </div>
                </div>
                <div className="toggle-Invalid-items">
                    <div className="d-flex align-items-center">
                        <span
                            className={`switch-button without-text mr-10 ${
                                this.props.showInvalidItems ? 'active' : 'not-active'
                            }`}
                            onClick={this.props.toogleInvalidItems}
                            title="Delayed"
                        >
                            <span className="switch-circle" />
                        </span>
                        <span>{t('domain_runs_qa.delayed')}</span>
                    </div>
                    <div className="d-flex align-items-center">
                        <span
                            className={`switch-button without-text mr-10 ${
                                this.props.showNewItems ? 'active' : 'not-active'
                            }`}
                            onClick={this.props.toogleNewItems}
                            title="Missing Items"
                        >
                            <span className="switch-circle" />
                        </span>
                        <span>{t('domain_runs_qa.missing_items')}</span>
                    </div>
                </div>
            </div>
        );
    }
}

export default withTranslation()(ExtraButtons);
